import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

/**
 * Configuración general. Los datos fiscales (CAI, emisor, correlativos) se administran ÚNICAMENTE en
 * Administración → Configuración de documentos y datos fiscales; el formulario fiscal antiguo se retiró
 * (su registro se conserva y sus diferencias se revisan en ese apartado).
 */
export default function Settings() {
  return (
    <Layout title="Configuración" subtitle="Parámetros generales del sistema">
      <div className="max-w-3xl bg-card border border-border/60 rounded-lg p-5 mb-5 flex items-start gap-4" data-testid="fiscal-moved">
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-wider text-agro-green font-medium">Datos fiscales y documentos</div>
          <div className="text-sm mt-1">
            El CAI, los datos del emisor, la numeración y las notas de los documentos se administran en
            <b> Configuración de documentos y datos fiscales</b>.
          </div>
        </div>
        <Link to="/admin/configuracion-documentos" data-testid="go-fiscal-config"
          className="shrink-0 px-4 py-2 text-sm bg-agro-green text-black font-medium rounded-md hover:bg-agro-green-hover">
          Abrir
        </Link>
      </div>
      <div className="max-w-3xl bg-card border border-border/60 rounded-lg p-6 mt-6 flex items-center justify-between gap-4" data-testid="regions-card">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-agro-green font-medium">Regiones de trabajo</div>
          <div className="text-sm text-text-secondary mt-1">Las regiones se administran en su propia sección: crear, editar, activar y desactivar.</div>
        </div>
        <Link to="/regiones" data-testid="go-regions" className="shrink-0 px-4 py-2 text-sm bg-agro-green text-black font-medium rounded-md hover:bg-agro-green-hover">Abrir</Link>
      </div>
    </Layout>
  );
}

